import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Utils} from "@amlCore/utils";
import {DictionaryService, ValidatorService} from "@amlCore/services";
import {AlertPanelComponent, AlertPanelService, AlertService} from "@amlCore/components";
import {FormBuilder, FormGroup} from "@angular/forms";
import {RegistriesService} from "../../../service";
import {RiskfactorClasses} from "../../../model";


@Component({
  selector: 'app-registry-riskfactor-classform',
  templateUrl: './riskfactorClassForm.component.html'
})
export class RiskfactorClassFormComponent implements OnInit {

  @ViewChild('alertObjSave') alertObjToSave: AlertPanelComponent;

  constructor(private regSrv: RegistriesService,
              private route: ActivatedRoute,
              protected alertPanelSrv: AlertPanelService,
              private alertSrv: AlertService,
              protected dictSrv: DictionaryService,
              private validationSrv: ValidatorService,
              private formBuilder: FormBuilder) {
  }

  id: string;
  formGroup: FormGroup;
  goBack = Utils.goBack;

  submitted = false;
  typeClassList: Array<any> = [];

  ngOnInit() {
    this.id = this.route.snapshot.params.id;

    this.typeClassList = this.dictSrv.getStaticData('typeClassList');

    this.initForm();
    this.setForm();
  }


  save() {
    if (this.formGroup.invalid) {
      this.submitted = true;
      this.alertObjToSave.open(this.alertPanelSrv.getErrorMsg('Не все поля заполнены корректно'));
      return;
    }
    this.regSrv.saveRiskfactorClass(this.id, this.formGroup.value).subscribe(data => {
      if (!this.id) {
        this.id = data.id;
      }
      this.alertObjToSave.open(this.alertPanelSrv.getSuccessMsg('Данные сохранены'));
      this.submitted = false;
    });
  }

  /**
   * Инициализация формы
   */
  private initForm() {
    this.formGroup = this.formBuilder.group({
      className: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      name: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      info: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      type: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      active: false
    });
  }

  /**
   * Установка значения формы
   */
  private setForm() {
    const data = this.route.snapshot.data.resolveData as RiskfactorClasses;
    if (data) {
      this.formGroup.patchValue(data);
    }
  }
}
